<template>
  <div class="workflow-type-chip-wrapper">
    <el-tooltip
      :content="isDisabled ? tooltipContent : ''"
      placement="bottom"
      effect="dark"
      popper-class="workflow-type-chip-tooltip"
      :disabled="!isDisabled"
    >
      <template #content>
        <div class="tooltip-content">
          {{ tooltipContent }}
        </div>
      </template>

      <template #default>
        <div
          class="workflow-type-chip"
          :class="{
            'is-disabled': isDisabled,
            'is-program': isProgram,
          'is-hovered': isHovered
        }"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
        @click="handleClick"
      >
    <!-- Program Icon (Purple) -->
    <svg v-if="shouldShowProgramIcon" xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
        <path class="icon-fill" d="M1.45455 14.5455C1.05455 14.5455 0.712121 14.403 0.427273 14.1182C0.142424 13.8333 0 13.4909 0 13.0909V2.90909C0 2.50909 0.142424 2.16667 0.427273 1.88182C0.712121 1.59697 1.05455 1.45455 1.45455 1.45455H7.27273V2.90909H1.45455V13.0909H11.6364V8.72727H13.0909V13.0909C13.0909 13.4909 12.9485 13.8333 12.6636 14.1182C12.3788 14.403 12.0364 14.5455 11.6364 14.5455H1.45455ZM2.90909 11.6364H4.36364V6.54545H2.90909V11.6364ZM5.81818 11.6364H7.27273V4.36364H5.81818V11.6364ZM8.72727 11.6364H10.1818V8.72727H8.72727V11.6364ZM12.3636 7.27273C12 7.27273 11.6424 7.21818 11.2909 7.10909C10.9394 7 10.6121 6.84242 10.3091 6.63636L10.0364 6.89091C9.89091 7.02424 9.71818 7.09091 9.51818 7.09091C9.31818 7.09091 9.15151 7.02424 9.01818 6.89091C8.88485 6.75758 8.81818 6.58788 8.81818 6.38182C8.81818 6.17576 8.88485 6.00606 9.01818 5.87273L9.30909 5.58182C9.11515 5.29091 8.9697 4.98182 8.87273 4.65455C8.77576 4.32727 8.72727 3.98788 8.72727 3.63636C8.72727 2.6303 9.08182 1.77273 9.79091 1.06364C10.5 0.354545 11.3576 0 12.3636 0H16V3.63636C16 4.64242 15.6455 5.5 14.9364 6.20909C14.2273 6.91818 13.3697 7.27273 12.3636 7.27273ZM12.3636 5.81818C12.9697 5.81818 13.4848 5.60606 13.9091 5.18182C14.3333 4.75758 14.5455 4.24242 14.5455 3.63636V1.45455H12.3636C11.7576 1.45455 11.2424 1.66667 10.8182 2.09091C10.3939 2.51515 10.1818 3.0303 10.1818 3.63636C10.1818 3.79394 10.197 3.94545 10.2273 4.09091C10.2576 4.23636 10.303 4.38182 10.3636 4.52727L12.2545 2.63636C12.3879 2.50303 12.5576 2.43636 12.7636 2.43636C12.9697 2.43636 13.1394 2.50303 13.2727 2.63636C13.4182 2.78182 13.4909 2.95455 13.4909 3.15455C13.4909 3.35455 13.4182 3.52727 13.2727 3.67273L11.3818 5.56364C11.5394 5.63636 11.7 5.69697 11.8636 5.74545C12.0273 5.79394 12.1939 5.81818 12.3636 5.81818Z" fill="#19859A"/>
    </svg>

    <!-- Workflow Icon (Blue) -->
    <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path class="icon-fill" d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM4.563 14.652C4.95 13.842 7.308 13.05 9 13.05C10.692 13.05 13.059 13.842 13.437 14.652C12.213 15.624 10.674 16.2 9 16.2C7.326 16.2 5.787 15.624 4.563 14.652ZM14.724 13.347C13.437 11.781 10.314 11.25 9 11.25C7.686 11.25 4.563 11.781 3.276 13.347C2.358 12.141 1.8 10.638 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 10.638 15.642 12.141 14.724 13.347ZM9 3.6C7.254 3.6 5.85 5.004 5.85 6.75C5.85 8.496 7.254 9.9 9 9.9C10.746 9.9 12.15 8.496 12.15 6.75C12.15 5.004 10.746 3.6 9 3.6ZM9 8.1C8.253 8.1 7.65 7.497 7.65 6.75C7.65 6.003 8.253 5.4 9 5.4C9.747 5.4 10.35 6.003 10.35 6.75C10.35 7.497 9.747 8.1 9 8.1Z"/>
    </svg>

    <span class="chip-text">{{ chipText }}</span>

    <!-- Change Type Icon (Right) -->
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 22 15" fill="none">
      <path class="icon-fill" d="M8 5H18V8L22 4L18 0V3H6V9H8V5ZM14 10H4V7L0 11L4 15V12H16V6H14V10Z"/>
    </svg>
  </div>
  </template>
  </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'WorkflowTypeChip',
  props: {
    isProgram: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  data() {
    return {
      isHovered: false
    };
  },
  computed: {
    chipText() {
      if (this.isHovered) {
        // When hovered: show convert text
        return this.isProgram ? 'CONVERT TO WORKFLOW' : 'CONVERT TO PROGRAM';
      }
      // When not hovered: show current text
      return this.isProgram ? 'CURRENT: PROGRAM' : 'CURRENT: WORKFLOW';
    },
    shouldShowProgramIcon() {
      // Show program icon when: isProgram is true, OR when hovered on workflow
      return (this.isProgram && !this.isHovered) || (this.isHovered && !this.isProgram);
    },
    shouldShowWorkflowIcon() {
      // Show workflow icon when: isProgram is false, OR when hovered on program
      return !this.isProgram || (this.isHovered && this.isProgram);
    },
    tooltipContent() {
      // Dynamic tooltip text based on isProgram
      return this.isProgram
        ? 'Program that has active assignees cannot be reverted to workflow'
        : 'Active Workflow has assigned patient(s) cannot be converted to Program';
    },
    shouldShowChangeTypeIcon() {
      // Show change type icon only when not disabled
      return !this.isDisabled;
    }
  },
  methods: {
    handleClick() {
      if (!this.isDisabled) {
        this.$emit('click');
      }
    }
  }
};
</script>

<style scoped>
.workflow-type-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 4px 16px;
  width: 280px;
  height: 28px;
  border-radius: 20px;
  transition: background-color 0.2s, color 0.2s;
  cursor: pointer;
}

/* Workflow state: not hover, not disabled */
.workflow-type-chip:not(.is-disabled):not(.is-hovered):not(.is-program) {
  background-color: #E4F3F5;
}

/* Program state: not hover, not disabled */
.workflow-type-chip:not(.is-disabled):not(.is-hovered).is-program {
  background-color: #E5F9EF;
}

/* Hover state (common) */
.workflow-type-chip:hover:not(.is-disabled) {
  background-color: #C5E3E7;
}

/* Disabled state */
.workflow-type-chip.is-disabled {
  background-color: #E0E0E0;
  cursor: not-allowed;
}

/* Wrapper styling to allow tooltip on disabled chip */
.workflow-type-chip-wrapper {
  display: inline-block;
}

/* Icon and text colors for Workflow state (not hover, not disabled) */
.workflow-type-chip:not(.is-disabled):not(.is-hovered):not(.is-program) .chip-text {
  color: #004879;
}

.workflow-type-chip:not(.is-disabled):not(.is-hovered):not(.is-program) svg:first-child{
  color: #004879;
}

.workflow-type-chip:not(.is-disabled):not(.is-hovered):not(.is-program) svg:last-child {
  color: #374957;
}

/* Icon and text colors for Program state (not hover, not disabled) */
.workflow-type-chip:not(.is-disabled):not(.is-hovered).is-program svg:first-child,
.workflow-type-chip:not(.is-disabled):not(.is-hovered).is-program .chip-text {
  color: #19859A;
}

.workflow-type-chip:not(.is-disabled):not(.is-hovered).is-program svg:last-child {
  color: #167487;
}

/* Hovered on Workflow: keep workflow colors */
.workflow-type-chip:hover:not(.is-disabled):not(.is-program).is-hovered svg:first-child {
  color: #004879;
}

.workflow-type-chip:hover:not(.is-disabled):not(.is-program).is-hovered .chip-text {
  color: #004879;
}

.workflow-type-chip:hover:not(.is-disabled):not(.is-program).is-hovered svg:last-child {
  color: #374957;
}

/* Hovered on Program: keep program colors */
.workflow-type-chip:hover:not(.is-disabled).is-program.is-hovered .chip-text {
  color: #19859A;
}

.workflow-type-chip:hover:not(.is-disabled).is-program.is-hovered svg:first-child{
  color: #19859A;
}

.workflow-type-chip:hover:not(.is-disabled).is-program.is-hovered svg:last-child {
  color: #167487;
}

/* Disabled state: all icons and text gray */
.workflow-type-chip.is-disabled svg {
  color: #979797;
}

.workflow-type-chip.is-disabled .chip-text {
  color: #979797;
}

.workflow-type-chip svg {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

.workflow-type-chip svg:last-child {
  width: 24px;
  height: 24px;
}

.chip-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Hide icon backgrounds as we use inline colors */
.workflow-type-chip .icon-bg {
  display: none;
}

.workflow-type-chip .icon-fill {
  fill: currentColor;
}

/* Tooltip styling */
:deep(.workflow-type-chip-tooltip) {
  background-color: #666 !important;
  border-radius: 2px;
  padding: 2px 16px;
  max-width: 300px;
}

:deep(.workflow-type-chip-tooltip .tooltip-content) {
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #ffffff;
  white-space: normal;
}
</style>
